import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Workflow } from '../../Model/Dto/Workflow/Workflow';
import { lastValueFrom } from 'rxjs';
import { Workflowplan } from '../../Model/Dto/Workflow/Workflowplan';
@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  private readonly apiWorkflowUrl = 'api/Workflow';
  private readonly apiWorkflowplanUrl = 'api/Workflowplan';

  constructor(private http: HttpClient) { }

  getWorkflows(customerId: string): Promise<Workflow[]> {
    const url = `${this.apiWorkflowUrl}/GetAll`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<Workflow[]>(url, options));
  }

  updateOrCreateWorkflow(updateWorkflow: Workflow, customerId: string): Promise<Workflow> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    }
    var result = this.http.post<Workflow>("api/Workflow/Update", updateWorkflow, options);
    return lastValueFrom(result);
  }

  deleteWorkflow(workflow: Workflow, customerId: string): Promise<Workflow> {
    const url = `${this.apiWorkflowUrl}/delete`;
    const params = new HttpParams().append('id', workflow.id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.delete<Workflow>(url, options));
  }

  runWorkflow(catalogId: string, workflowId: string, customerId: string, workflowPlanId: string): Promise<void> {
    const url = `${this.apiWorkflowUrl}/RunWorkflow`;
    const params = new HttpParams().append('customerId', customerId).append('catalogId', catalogId).append('workflowId', workflowId).append('workflowPlanId', workflowPlanId);
    const options = { params };
    return lastValueFrom(this.http.get<void>(url, options));
  }

  getWorkflowplans(catalogId: string, customerId: string): Promise<Workflowplan[]> {
    const url = `${this.apiWorkflowplanUrl}/GetAllWorkflowplansByCatalogId`;
    const params = new HttpParams().append('customerId', customerId).append('catalogId', catalogId);
    const options = { params };
    return lastValueFrom(this.http.get<Workflowplan[]>(url, options));
  }

  updateOrCreateWorkflowplan(updateWorkflowplan: Workflowplan, customerId: string): Promise<Workflowplan> {
    const url = `${this.apiWorkflowplanUrl}/Update`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<Workflowplan>(url, updateWorkflowplan, options));
  }

  deleteWorkflowplan(workflowplan: Workflowplan, customerId: string): Promise<Workflowplan> {
    const url = `${this.apiWorkflowplanUrl}/delete`;
    const params = new HttpParams().append('id', workflowplan.id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.delete<Workflowplan>(url, options));
  }

  getAllWorkflowplansByWorkflowId(workflowId: string, customerId: string): Promise<Workflowplan[]> {
    const url = `${this.apiWorkflowplanUrl}/GetAllWorkflowplansByWorkflowId`;
    const params = new HttpParams().append('workflowId', workflowId).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<Workflowplan[]>(url, options));
  }
}